import { useLocation } from "@tanstack/react-router";
import { ReactNode, useRef, useState } from "react";

interface HeroProps {
  backgroundImage: string;
  children: ReactNode;
}

function HeroContent({ backgroundImage, children }: HeroProps) {
  const [showImage, setShowImage] = useState(false);
  const [showContent, setShowContent] = useState(false);
  const imageRef = useRef<HTMLImageElement>(null);

  // Handle image load and trigger staggered animation
  const handleImageLoad = () => {
    // Start image fade-in immediately
    setShowImage(true);
    // Start content fade-in after a delay
    setTimeout(() => {
      setShowContent(true);
    }, 400); // 400ms delay for staggered effect
  };

  return (
    <section
      className={`relative mt-12 aspect-square w-screen overflow-hidden xl:mt-0 xl:aspect-auto xl:h-screen`}
    >
      {/* Background Image */}
      <img
        ref={imageRef}
        src={backgroundImage}
        alt=""
        className={`tg-hero__image ${showImage ? "tg-hero__image--visible" : ""}`}
        onLoad={handleImageLoad}
      />

      {/* Content Overlay */}
      <div className="tg-section__wrapper relative z-10">
        <div className="tg-section__grid items-center justify-center text-white">
          <div
            className={`tg-hero__content ${showContent ? "tg-hero__content--visible" : ""}`}
          >
            {children}
          </div>
        </div>
      </div>

      {/* Scroll Indicator - Mobile Only */}
      <div className="tg-scroll-indicator h-8 w-8">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          fill="#fff"
          viewBox="0 0 256 256"
        >
          <path d="M216.49,104.49l-80,80a12,12,0,0,1-17,0l-80-80a12,12,0,0,1,17-17L128,159l71.51-71.52a12,12,0,0,1,17,17Z"></path>
        </svg>
      </div>
    </section>
  );
}

// Wrapper component that uses key to reset state on route changes
export function Hero(props: HeroProps) {
  const location = useLocation();

  // Use pathname as key to force component remount on route changes
  return <HeroContent key={location.pathname} {...props} />;
}
